const boardroom = {
  selectAdvisors: "Select Advisors",
  quickSelect: "Quick Select",
  presetAll: "⚡ All",
  presetBusiness: "🏛️ Business",
  presetTechnical: "💻 Technical",
  readyQuestions: "Ready Questions",
  selectAndAsk: "Select advisors and ask a question",
  advisorsSelected: "advisors selected",
  advisors: "advisors",
  newQuestion: "New Question",
  askPlaceholder: "Ask",
  toSend: "to send",
  newLine: "new line",
  send: "Ask",
  responses: "responses",
  thinking: "Thinking...",
} as const;
export default boardroom;
